module.exports = __webpack_public_path__ + "static/img/14000603.82ff3ef5.png";